import globals from '../../../globals';
import { _sendWithAxios, _sendWithAxiosBlob } from '../../api'

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

export const cadastrarUsuarioSeller = async (data, idEmpresa) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/cadastrar-usuario/Seller/${idEmpresa}`, 'POST', data)
}

export const listarUsuarioSeller = async (idEmpresaSeller, page) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}UsuarioSeller/listar-usuarios-seller/${idEmpresaSeller}/${page}/10`, 'GET')
}

export const listarUsuarioSellerComFiltro = async (filtro,idEmpresaSeller, page) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}UsuarioSeller/listar-usuarios-seller/${filtro}/${idEmpresaSeller}/${page}/10`, 'GET')
}

export const atualizarUsuarioSeller = async (data) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/atualizar-usuario/`, 'PUT', data)
}

export const detalheUsuarioSeller = async (idUsuarioSeller) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/detalhe-usuario/${idUsuarioSeller}`, 'GET')
}

export const inativarUsuarioSeller = async (idUsuario) => {
    return await _sendWithAxios(`${REACT_APP_URL_BASE_API}User/inativar-usuario/${idUsuario}`, 'PUT')
}

export const gerarRelatorioUsuariosSeller = async (idEmpresa) => {
    return await _sendWithAxiosBlob(`${REACT_APP_URL_BASE_API}UsuarioSeller/extrair-usuarios-seller/${idEmpresa}`, 'GET')
}
